import React from "react";
import { Modal, Form, Input, message } from "antd";
import Instance from "../../AxiosConfig";

const AddCompanyModal = ({ open, onClose, refresh }) => {
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    try {
      await Instance.post("/companyDetails", values);
      message.success("Company added");
      form.resetFields();
      onClose();
      refresh();
    } catch (err) {
      message.error(err?.response?.data?.message || "Error");
    }
  };

  return (
    <Modal
      title="Add Company"
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="companyName" label="Company Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="addressLine1" label="Address">
          <Input />
        </Form.Item>

        <Form.Item name="city" label="City">
          <Input />
        </Form.Item>

        <Form.Item name="state" label="State">
          <Input />
        </Form.Item>

        <Form.Item name="pincode" label="Pincode">
          <Input />
        </Form.Item>

        <Form.Item name="email" label="Email">
          <Input />
        </Form.Item>

        <Form.Item name="phone" label="Phone">
          <Input />
        </Form.Item>

        <Form.Item name="gstNumber" label="GST">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCompanyModal;